import React from 'react';
import { Button } from '@up-riac/bespoke-ui';

export const MegaMenuCTA = ({ to, onPress, src, buttonLabel, id }: {to: string, onPress?: () => void, src: string, buttonLabel: string, id: string}) => {
  return (
    <Button unstyled
      className='flex flex-col ml-auto px-3 pb-5 relative w-full max-w-[405px] h-full items-stretch justify-end aspect-video'
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(23, 23, 23, 0) 65.28%, #171717 104.93%), url(${src})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      to={to}
      id={id}
      onPress={onPress}
    >
      <Button divButton buttonType='outlined' fullWidth id={`${id}-div-button`}>
        {buttonLabel}
      </Button>
    </Button>
  );
};
